import keys from '@debbie/common/dist/cache/keys.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as creditors from '@debbie/cortex/dist/api/creditors.js';
import { creditorsEntity, useAllCreditors, } from '@debbie/cortex/dist/creditors/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import q from '@debbie/cortex/dist/query.js';
import { useVoucherApplications } from '@debbie/cortex/dist/voucher-applications/index.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { Size } from '../../design-system.js';
import THEME from '../../theme.js';
import { errorNotification } from '../../utils/errors.js';
import Checkbox from '../Checkbox.js';
import { ChevronDown, ChevronRight } from '../Icons/index.js';
import VoucherApplication from './VoucherApplication.js';
const CreditorVoucherApplications = (props) => {
    const lang = useSelector((s) => s.lang);
    const setCustomVouchers = useMutation((to) => creditors.update(props.creditorId, { customVoucherApplications: to }), {
        onSuccess: () => q.invalidate(keys.write.modify(creditorsEntity, props.creditorId)),
        onError: (err) => errorNotification(lang, err, 'update', lang.errorEntities.creditor),
    });
    const allCreditorsLoadable = useAllCreditors();
    const allCreditors = h.hasData(allCreditorsLoadable)
        ? allCreditorsLoadable.data
        : null;
    const voucherApplications = useVoucherApplications();
    const [open, setOpen] = useState(false);
    const relevantCreditorId = props.creditorId || null;
    const creditorMap = allCreditors != null
        ? allCreditors.reduce((acc, creditor) => {
            acc[creditor.creditorId] = creditor;
            return acc;
        }, {})
        : {};
    const creditor = creditorMap[props.creditorId];
    const active = creditor.customVoucherApplications;
    const relevantApplications = h.hasData(voucherApplications)
        ? voucherApplications.data.filter((va) => va.creditorId == relevantCreditorId)
        : [];
    return (React.createElement(Wrapper, null,
        creditorMap[props.creditorId] != null ? (React.createElement(Creditor, null,
            React.createElement(CreditorLeft, null,
                React.createElement(Chevron, null, open ? (React.createElement(ChevronDown, { onClick: () => {
                        setOpen(false);
                    } })) : (React.createElement(ChevronRight, { onClick: () => {
                        setOpen(true);
                    } }))),
                React.createElement(CreditorLink, { to: `/creditors/${props.creditorId}` },
                    creditorMap[props.creditorId].name,
                    " (",
                    relevantApplications.length,
                    ")")),
            React.createElement(Checkbox, { size: Size.Small, style: {
                    marginBottom: '0px',
                    marginRight: '10px',
                }, checked: active, loading: setCustomVouchers.isLoading, disabled: setCustomVouchers.isLoading, onChange: (e) => {
                    setCustomVouchers.mutate(e.target.checked);
                } }))) : null,
        open && h.hasData(voucherApplications)
            ? relevantApplications.map((va) => {
                return (React.createElement(ApplicationsListItem, { key: va.id },
                    React.createElement(VoucherApplication, { voucherApplication: va, inactive: !active })));
            })
            : null));
};
const Wrapper = styled.div `
  width: 100%;
`;
const Creditor = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${THEME.BORDER_STRONG};
  width: 100%;
`;
const CreditorLink = styled.p ``;
const CreditorLeft = styled.div `
  display: flex;
  align-items: center;
`;
const ApplicationsListItem = styled.div `
  padding: 10px;
  border-bottom: 1px solid ${THEME.BORDER_STRONG};
`;
const Chevron = styled.div `
  cursor: pointer;
  padding: 10px;
`;
export default CreditorVoucherApplications;
//# sourceMappingURL=CreditorVoucherApplications.js.map